document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.featured-collection-tabs').forEach((section) => {
    const tabs = Array.from(section.querySelectorAll('.featured-collection-tabs__tab'));
    const panels = Array.from(section.querySelectorAll('.featured-collection-tabs__panel'));

    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab, index) => {
      tab.dataset.tabIndex = index.toString();
      tab.addEventListener('click', () => {
        const idx = tab.dataset.tabIndex;

        tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach((panel, pIndex) => {
          const active = pIndex.toString() === idx;
          panel.classList.toggle('hidden', !active);
          panel.classList.toggle('is-active', active);
        });
      });
    });
  });
});

